import '../App.css';
import { useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { useAppContext } from '../context/Context';
import { storeOrder } from './queries';

function Confirmation({setConf, setMessage, setReceipt, currentCart}) {
    const stripe = useStripe()

    // context provided
    const { options, handleOptions } = useAppContext();

    useEffect(() => {
        if (!stripe){
            return;
        }
        async function getSecret(){
            const clientSecret = new URLSearchParams(window.location.search).get(
                        'payment_intent_client_secret'
                    );
            await handleOptions(clientSecret)
        }
        if (options.clientSecret == null){
            getSecret()
        }
        if (options.clientSecret != null){

            stripe
                .retrievePaymentIntent(options.clientSecret)
                .then(({paymentIntent}) => {
                    switch (paymentIntent.status) {
                        case 'succeeded':
                            setMessage('Success')
                            storeOrder(options.clientSecret, currentCart)
                            setReceipt(true)
                            break;
                        case "processing":
                            setMessage('Processing')
                            break;
                        case "requires_payment_method":
                            setMessage("Payment failed, please try again")
                            setConf(false)
                            break;
                        default:
                            setMessage("Payment failed, please try again")
                            setConf(false)
                            break;
                    }
                })
        }
    }, [stripe])

  return <div className='spinner' />;
}

export default Confirmation;